import React, { useRef} from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeCollection() {
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1800,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="arrowLeft" />
        </div>
        <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
            <Icons name="arrowRight" />
        </div>
        </>
    );

  return (
    <>
    <section className="home-collection bodygap">
        <Slider {...settings} ref={sliderRef}>
            <div>
                <div className="collection-slideitem">
                    <img src="/image/collection-1.webp" className="img-responsive" alt="collection" loading="lazy"/>
                    <div>
                        <h4 className="heading">Ethereal Lehengas Collection</h4>
                        <Link to={"/wedding-dress-designers"} className="default-btn">Explore</Link>
                    </div>
                </div>
            </div>

            <div>
                <div className="collection-slideitem">
                    <img src="/image/collection-2.webp" className="img-responsive" alt="collection" loading="lazy"/>
                    <div>
                        <h4 className="heading">Regal couture Collection</h4>
                        <Link to={"/mehandi-dresses"} className="default-btn">Explore</Link>
                    </div>
                </div>
            </div>
        </Slider>
        <CustomArrows />
    </section>
    </>
  )
}
